import {
  Component,
  computed,
  contentChildren,
  viewChildren,
} from '@angular/core';
import { UI_DIRECTIVES } from '../../directives';
import { TemplateDirective } from '../../directives/template.directive';
import { DisposableComponent } from './disposable.component';

@Component({
  selector: 'maximizer-template-component',
  template: ``,
  imports: [UI_DIRECTIVES],
})
export class TemplateComponent extends DisposableComponent {
  childTemplates = viewChildren(TemplateDirective);
  contentTemplates = contentChildren(TemplateDirective);
  templates = computed(() => {
    return (this.childTemplates() ?? []).concat(this.contentTemplates() ?? []);
  });

  getTemplate(id: string) {
    return (
      this.templates().find((template) => template.templateId === id)
        ?.template || null
    );
  }
}
